import React from 'react';
import * as PropTypes from 'prop-types';
import InformationCircleIcon from '@heroicons/react/24/solid/InformationCircleIcon';
import { useTranslation } from 'react-i18next';
import matchesSearchTerm from '@medflex/utils/matchesSearchTerm';
import Button from '../Button';
import Tooltip from '../Tooltip';
import LinkifyText from '../LinkifyText';
import SubContactTitle from '../SubContactTitle';

const MAX_TRUNCATE_LENGTH = 130;

const Note = ({ value, onClick }) => {
  const { t } = useTranslation('components');
  const shouldTruncate = value && value.length > MAX_TRUNCATE_LENGTH;

  return (
    <div className="max-w-[230px] whitespace-pre-line">
      <LinkifyText>
        {shouldTruncate ? value.substring(0, MAX_TRUNCATE_LENGTH).trim() : value}
      </LinkifyText>
      {shouldTruncate && (
        <>
          <span>...</span>
          <Button kind="link" className="inline ml-1" onClick={onClick}>
            {t('ContactList.ContactListItemSubtitle.showMore')}
          </Button>
        </>
      )}
    </div>
  );
};

const Divider = () => <div className="text-slate-400 text-sm mx-2">|</div>;

const ContactListItemSubtitle = ({
  note,
  text,
  parentName,
  onClickMainContact,
  onClickShowMore,
  toHighlight,
}) => {
  const handleClick = event => {
    event.preventDefault();

    if (onClickShowMore) {
      onClickShowMore(event);
    }
  };

  const higlightNotesIcon = () => {
    return matchesSearchTerm(toHighlight, note);
  };

  return (
    <div className="flex items-center space-x-1">
      <div className="font-semibold truncate">{text}</div>
      {note && (
        <Tooltip title={<Note value={note} />}>
          <Button kind="link" className="inline" onClick={handleClick}>
            <InformationCircleIcon
              className={`w-5 text-slate-500 ${
                toHighlight && higlightNotesIcon() && 'bg-amber-200'
              } `}
            />
          </Button>
        </Tooltip>
      )}
      {parentName && <Divider />}
      {parentName && (
        <SubContactTitle onOpenMainContact={onClickMainContact} parentName={parentName} />
      )}
    </div>
  );
};

ContactListItemSubtitle.defaultProps = {
  note: null,
  onClickShowMore: () => {},
  onClickMainContact: () => {},
  parentName: null,
  toHighlight: '',
};

ContactListItemSubtitle.propTypes = {
  note: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  onClickShowMore: PropTypes.func,
  onClickMainContact: PropTypes.func,
  parentName: PropTypes.string,
  toHighlight: PropTypes.string,
};

export default ContactListItemSubtitle;
